import PropTypes from 'prop-types';
import React from 'react';
import { SearchContext } from '../common/SearchContext.js';
import { AddedToCart } from '../common/AddedToCart.js';
import { giveToSchool } from '../common/giveToSchool.js';


const AmountButton = ({schoolId, amount, setSelectedAmount, setShowAddedToCart}) => {
    const onClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setSelectedAmount(amount);

        const onSuccess = () => {
            setShowAddedToCart(true);
        }
        const onFailure = () => {
            // SLG2TODO ask Product what to say if this fails
        }
        giveToSchool(schoolId, amount, onSuccess, onFailure);
    }

    return <button className="button-secondary small suggested-amount" onClick={onClick}>${amount}</button>;
}

const amounts = [50, 100, 250, 500];

export const SchoolGiveButtons = ({schoolId}) => {
    const [open, setOpen] = React.useState(false);
    const [selectedAmount, setSelectedAmount] = React.useState(null);
    const [showAddedToCart, setShowAddedToCart] = React.useState(false);
    const { isSchoolLevelGivingEnabled } = React.useContext(SearchContext);

    let result;
    let extraStyles = {};
    if (!isSchoolLevelGivingEnabled) {
        result = null;
    } else if (showAddedToCart) {
        const onClose = () => { setShowAddedToCart(false); }
        result = <AddedToCart amount={selectedAmount} onClose={onClose} />;
        // z-index one more than school-give-button-holder default
        extraStyles = { zIndex: 5 };
    } else if (open) {
        const buttons = amounts.map((amount) => {
            return (
                <AmountButton
                    schoolId={schoolId}
                    amount={amount}
                    setSelectedAmount={setSelectedAmount}
                    setShowAddedToCart={setShowAddedToCart}
                />
            );
        });
        result = <div>{buttons}</div>;
    } else {
        const onClick = (e) => {
            e.preventDefault();
            e.stopPropagation();
            setOpen(true);
        }
        result = <button className="button-secondary small suggested-amount" onClick={onClick}>Give</button>
    }

    if (result === null) {
        return null;
    } else {
        // Shared CSS class to handle z-index.
        // Overwrite CSS when added-to-cart popup is showing to make sure siblings' give-buttons don't poke through.
        return <div style={extraStyles} className="suggested-give-amounts"><div className="anchored-amounts">{result}</div></div>;
    }
}
SchoolGiveButtons.propTypes = {
    schoolId: PropTypes.number.isRequired,
}
